import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* Tell the page a newer app is sitting in the wings.
 *
 * The service worker no longer calls skipWaiting on install, so a new deploy
 * installs and then WAITS instead of replacing the running app mid-sentence.
 * That waiting worker is what the version stamp offers as "Update". */
function announceUpdate(reg) {
  window.__ebUpdate = reg;
  window.dispatchEvent(new CustomEvent("eb:sw-update", { detail: reg }));
}

if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          // An update that finished installing while the app was closed is
          // already waiting by the time we get here - there is no updatefound
          // event coming for it, so check outright.
          if (reg.waiting && navigator.serviceWorker.controller) announceUpdate(reg);

          reg.addEventListener("updatefound", () => {
            const sw = reg.installing;
            if (!sw) return;
            sw.addEventListener("statechange", () => {
              // No controller means this is the first install, not an update:
              // nothing is being replaced, so there is nothing to announce.
              if (sw.state === "installed" && navigator.serviceWorker.controller) {
                announceUpdate(reg);
              }
            });
          });

          // A tab left open for a day would otherwise never look again.
          setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
        })
        .catch((err) => console.warn("EB service worker registration failed:", err));
    });

    // The new worker taking control is the moment the swap actually happens.
    // Reload once, so the page and the worker serving it agree.
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
}
